import { Endpoint } from "src/app/api/api.decorator"

@Endpoint('languages', false)
export class Language {
  id!: number
  name!: string
  initials!: string
}
